// imports
import React from 'react';
import { Link } from '@react-router';
import { pxToRem } from '@withjoy/joykit/theme';
import { JoyKitThemeProvider } from '@withjoy/joykit';

// local imports
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { TravelCurrencySelector } from '@shared/components/TravelCurrencySelector';
import { TopBarContainer, LogoContainer, CurrencySelectorContainer } from './EventTopBar.styles';
import { TelemetryProvider, useEventTopBarTelemetry } from './EventTopBar.telemetry';

interface EventTopBarProps
  extends Readonly<{
    eventHandle: string;
  }> {}

const EventTopBarContent: React.FC<EventTopBarProps> = ({ eventHandle }) => {
  const [isCurrencySelectorEnabled] = useIsFeatureEnabled('travelGuestCurrencySwitch');
  const telemetry = useEventTopBarTelemetry();

  const handleLogoClick = useEventCallback(() => {
    telemetry.logoClicked();
  });

  return (
    <TopBarContainer>
      <LogoContainer
        as={Link}
        to={`/${eventHandle}`}
        onClick={handleLogoClick}
      >
        <JoyLogo
          width={pxToRem(48)}
          height={pxToRem(30)}
          color="mono14"
        />
      </LogoContainer>

      <JoyKitThemeProvider>
        <CurrencySelectorContainer>
          <TravelCurrencySelector isEnabled={isCurrencySelectorEnabled} />
        </CurrencySelectorContainer>
      </JoyKitThemeProvider>
    </TopBarContainer>
  );
};

export const EventTopBar: React.FC<EventTopBarProps> = ({ eventHandle }) => {
  return (
    <TelemetryProvider>
      <EventTopBarContent eventHandle={eventHandle} />
    </TelemetryProvider>
  );
};
